// src/shared-components/forms/add-board-content/add-post/inside-header/components/SavePostDraft.jsx
import { useEffect, useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import Loader from '@/shared-components/loader/Loader';
import Text from '@/shared-components/text/components/Text';

/**
 * Inline Save-Draft button for post editor.
 * - formState: current post form state
 */
export default function SavePostDraft({
  formState,
  savePost
}) {
  const t = useTranslations('common.forms.board_editor');
  const [loading, setLoading]   = useState(false);
  const [success, setSuccess]   = useState(false);
  const [plainTextToChange, setPlainTextToChange] = useState('');

  useEffect(() => {
    setPlainTextToChange(formState.plainText);
  }, []);

  const hasChanges = plainTextToChange !== formState.plainText;
  // Clear “Saved!” after 2s
  useEffect(() => {
    if (success) {
      const t = setTimeout(() => setSuccess(false), 2000);
      return () => clearTimeout(t);
    }
  }, [success]);

  useEffect(() => {
    if (hasChanges && success) setSuccess(false);
  }, [hasChanges, success]);

  async function saveDraft() {
    if (!hasChanges || loading) return;  // only when changed
    setLoading(true);

    await savePost();

    setLoading(false);
    setSuccess(true);

    setPlainTextToChange(formState.plainText);
  }

  const label = success ? t('saved') : t('save');

  const disabled = !hasChanges || loading;

  return (
    <Text
      className={[
        `board-header__item save-draft ${disabled ? 'disabled' : ''} ${success ? 'read-only' : ''}`,
        "font-size-medium"
      ].filter(Boolean).join(" ")}
      onClick={disabled ? undefined : saveDraft}>
      {label}
      {loading && <Loader inline className="board-header__spinner" thin />}
    </Text>
  );
}
